<div class="filter-tools">
  <app-select
    id="blog-category-select"
    [options]="categoryOptions()"
    [value]="activeCategory() ?? ''"
    [placeholder]="copy.categoryPlaceholder"
    (valueChange)="onCategorySelect($event)"
  />

  <app-select
    id="blog-tag-select"
    [options]="tagOptions()"
    [value]="activeTag() ?? ''"
    [placeholder]="copy.tagPlaceholder"
    (valueChange)="onTagSelect($event)"
  />

  <app-blog-search
    class="filter-tools__search"
    [value]="searchValue()"
    (searchChange)="searchChange.emit($event)"
  />

  <!-- B131: sin filtros no se pinta; con filtros, también el 0. -->
  @if (resultsCount() !== null) {
    <span class="filter-tools__counter">
      {{ copy.resultsCount(resultsCount()!) }}
    </span>
  }
</div>
